<script>
import Header from './Header.vue';

export default {
  components: {
    'header-component': Header
  },
  mounted() {
      window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
      handleScroll: function () {
        if (this.scTimer) return;
        this.scTimer = setTimeout(() => {
          this.scY = window.scrollY;
          clearTimeout(this.scTimer);
          this.scTimer = 0;
        }, 100);
      },
      toTop: function () {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      },
    },
}
</script>

<template>
  <div role="main">
    <div class="top-wrap">
      <div class="top-content">
        <div class="top-banner">
          <header-component></header-component>

          <h1>Site Guide</h1>
        </div>

      </div>
       <p>
          The purpose of this website is to provide resources and information for<br>
          Population Health Decision Makers who want to implement a change in their treatment strategy<br>
          for adults living with schizophrenia, including earlier adoption of long-acting injectable antipsychotics (LAIs).
        </p>
    </div>

    <div class="list-content">
      <div class="list-wrap">
        <div class="list-item">
          <p class="list-item-tit">The Sections</p>

          <p class="less-bottom-margin">This website is divided into 4 main sections:</p>
          <ul class="no-top-margin">
            <li>
              <i>Population Identification Processes</i>—This section provides resources for understanding the patient identification process and how to identify patient subgroups that could benefit from LAIs based on your data
            </li>
            <li>
              <i>Expanding Internal Awareness</i>—This section is dedicated toward understanding the details of processes surrounding LAIs and enhancing awareness of LAIs as a treatment option for adults living with schizophrenia
            </li>
            <li>
              <i>Collaborative Care Resources</i>—This section contains resources that:
              <ul class="sublist">
                <li>
                  Can inform clinicians on the benefits of LAIs
                </li>
                <li>
                  Can be used with patients and caregivers to promote their involvement in treatment plans
                </li>
                <li>
                  Can be shared directly with the patient and/or caregiver
                </li>
              </ul>
            </li>
            <li>
              <i>Process Evaluation</i>—This section provides tools to assist in the evaluation of planned or implemented processes related to LAIs
            </li>
          </ul>

          <p class="list-item-tit">Resources</p>
          <p>
            There are a variety of downloadable and viewable resources on the website to help you in utilizing LAIs in your organization. These resources include videos, Word documents, PowerPoint presentations, PDFs, and links that redirect you to separate websites. Each resource is labeled with an icon to easily identify the file type.
          </p>

          <p class="list-item-tit">Content Filters</p>

          <p class="less-bottom-margin">The Resource Library utilizes a filter function that allows users to categorize content into:</p>
          <ul class="no-top-margin less-bottom-margin">
            <li>Resources for Caregivers</li>
            <li>Resources for Patients</li>
            <li>Resources for the Treatment Team</li>
            <li>Resources to Address Barriers to LAIs</li>
          </ul>
          <p class="no-top-margin">Simply click the drop-down menu labeled "FILTER RESOURCES BY" and select the categories of your choice.</p>

          <p class="list-item-subtit">
            For more information, please contact your local Janssen Account Manager or Field Based Medical Staff (FBMS).
          </p>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>
#app > div {
  width: 100%;
  }

/*TOP */

  .top-wrap{
    background: rgb(0,18,82);
    background: linear-gradient(0deg, rgba(0,18,82,1) 0%, rgba(0,70,126,1) 50%, rgba(0,70,126,1) 100%);
    color: #ffffff;
    padding-bottom: 20px;
    width: 100%;
  }

  .top-wrap p{
    font-size: 18px;
    line-height: 24px;
    margin: 27px auto 18px auto;
    text-align: center;
    width: 90%;
  }
  .top-content{
    background: linear-gradient(to top, #0079A8, #0084B8);
    border-radius: 0 0 0 100px;
    margin-left: 3%;
    padding-bottom: 50px;
    width: 97%;
  }

  .top-banner{
    background: url(../img/banner-bg.png) no-repeat 0 0;
    background-size: cover;
    border-radius: 0 0 0 100px;
    height: 320px;
    margin-left: 1.5%;
    width: 98.5%;
  }

.top-banner h1{
  display: block;
  font-family: Gotham, sans-serif;
  font-size: 36px;
  line-height: 46px;
  margin: 68px auto 20px auto;
  text-align: center;
}
.top-banner h2{
  display: block;
  font-family: GothamBook, sans-serif;
  font-size: 22px;
  font-style: italic;
  font-weight: 100;
  margin: 0 auto;
  text-align: center;
  width: 100%;
}

.top-banner sup {
  font-size: 11px;
  font-weight: 400;
  margin: 0 0 0 2px;
  vertical-align: text-top;
}

.top-banner section{
  font-family: GothamBook, sans-serif;
  font-size: 18px;
  margin: 40px auto 0 auto;
  text-align: center;
  width: 1040px;
}

.top-content p.banner-footer{
  font-family: GothamBook, sans-serif;
  font-size: 24px;
  text-align: center;
}

.bottom-banner{
  color: #00a0df;
  display: block;
  font-family: GothamBook, sans-serif;
  font-size: 20px;
  font-weight: 700;
  margin: 70px auto 0 auto;
  text-align: left;
  width: 1120px;
}

.bottom-banner-text{
  color: #ffffff;
  font-family: GothamBook, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}

.bottom-banner-text sup{
  font-size: 11px;
  font-weight: 400;
  position: relative;
  top: -0.2em;
  vertical-align: top;
}

.list-content{
  background: #eeeef3;
  margin: 0 auto;
  padding-bottom: 50px;
  position: relative;
  width: 100%;
}

.list-wrap{
  background: #eeeef3;
  color: #000000;
  display: block;
  font-family: GothamBook, sans-serif;
  font-size: 16px;
  line-height: 20px;
  margin: 65px auto;
  width: 90%;
}

.list-wrap ul, .list-wrap ol{
  padding-left: 20px;
}
.list-wrap ul li{
  padding-bottom: 10px;
  text-indent: -9px;
  color: #000000;
}

.list-wrap ol li{
  padding-bottom: 10px;
  padding-left: 8px;
}

.list-wrap ol li::marker{
  color: #00a0df;
  font-weight: bold;
  margin-right: 10px;
}

.list-wrap ul li::before{
  color: #000000;
  content: "\2022";
  font-weight: bold;
  display: initial;
  margin-left: -10px;
  padding-right: 10px;
}

.list-item{
  background-color: #ffffff;
  border-radius: 0 35px 0 35px;
  box-shadow: 10px -5px 30px 0px rgba(0,0,0,0.15);
  -moz-box-shadow: 10px -5px 30px 0px rgba(0,0,0,0.15);
  -webkit-box-shadow: 10px -5px 30px 0px rgba(0,0,0,0.15);
  padding: 22px 42px;
  position: relative;
  vertical-align: top;
}

.list-item-tit{
  font-family: GothamBook, sans-serif;
  font-size: 20px;
  color: #000000;
  font-weight: bold;
  line-height: 24px;
}

.list-item-subtit{
  font-weight: bold;
  color:#000000;
}

.no-top-margin{
  margin-top: 0;
}

li ul.sublist{
  margin-top: 10px;
}

li ul.sublist li::before{
  content: "–";
  padding-right: 0px;
  margin-right: 0;
}


.less-bottom-margin{
  margin-bottom: 5px;
  color:#000000;
}

.top-link{
  background: url(../img/icon-backToTop.png) no-repeat center right;
  bottom: 35px;
  color: #A65103;
  font-family: GothamMedium, sans-serif;
  font-size: 18px;
  position: absolute;
  right: 135px;
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  line-height: 42px;
  padding-right: 56px;
}

.site-guide, #menuToggle, #boton, .home{
  display: none;
}

@media screen and (min-width:881px){
  .site-guide{
    background-color: #98b0ca !important;
  }

  .site-guide a{
    color: #becddd !important;
  }
}

@media screen and (max-width: 880px){

   .top-banner{
    background: url(../img/banner-mobile4-bg.png) no-repeat 0 0;
    background-size: cover;
    border-radius: 0 0 0 100px;
    margin-left: 1.5%;
    padding-bottom: 46px;
    width: 98.5%;
  }

  .top-banner section{
    font-family: GothamBook, sans-serif;
    font-size: 28px;
    line-height: 30px;
    width: 86%;
  }
  .top-banner section p{
    margin: 23px 0;
  }

  .top-content p.banner-footer{
    font-size: 30px;
    margin: 24px auto;
    width: 73%;
  }

  .list-wrap{padding-left: 0px;}

  .top-banner h2{
    width: 96%;
  }

  .bottom-banner{
    padding-left: 60px;
    padding-right: 60px;
    width: calc(100% - 120px);
  }

  .step-item-desc-wrap{
    width: 95%;
  }

  .step-item{
    text-align: center;
  }

  .step-circle{
    margin: 60px 0 45px 0;
  }

  .step-item-desc-wrap{
    text-align: left;
  }

  .list-wrap{
    text-align: center;
    width: 100%;
  }

  .list-item{
    margin: 0 auto;
    text-align: left;
    width: 80%;
  }

  .list-item .button{
    width: 230px;
    background-size: contain;
  }

  .body{
    width: 90%;
  }

  .body .subhead{
    width: 100%;
  }

  .body-list-wrap, .body .references, .body-list-item button, .body-list-item .button{
    width: 100%;
  }

  .body-list-item {
    margin-right: 37px;
    width: 300px;
  }

  .list-item:nth-child(2n) {
    margin: 0;
  }

  .list-item:nth-child(3n) {
      margin: 0 32px 78px 0;
  }

  .body-list-item:nth-child(2n) {
    margin: 0;
  }

  .body-list-item:nth-child(3n) {
    margin: 0 32px 78px 0;
  }

  .list-content .subhead, .list-content .subhead-description{
    padding-left: 37px;
    padding-right: 37px;
    width: calc(100% - 74px);
  }

  .top-link{
    right: 35px;
  }

}


@media screen and (max-width: 415px){

  .resources .resource_info_wrap{
    border-right: 0;
    margin: 0 0 25px 0;
  }

  .resources div a{
    display: block;
    height: 55px;
  }

  .resources > div button{
    width: 100%;
  }

  .resources > div, .resources div:nth-child(2n){
    width: 100%;
  }

  .top-banner sup {
    font-size: 9px;
  }

  .bottom-banner{
    padding-left: 30px;
    padding-right: 30px;
    width: calc(100% - 60px);
  }

  .list-item{
    margin: 0 0 60px 0px;
    padding: 22px 37px;
  }

  .top-banner section{
    font-size: 23px;
  }

  .top-content p{
    width: 90%;
    font-size: 14px;
    font-weight: 600;
  }

  .body{
    width: 86%;
  }

  .body-list-item, .body-list-item:nth-child(2n), .body-list-item:nth-child(3n), .list-item:nth-child(2n), .list-item:nth-child(3n){
    margin: 0 32px 78px 20px;
  }

  .top-content{
    padding-bottom: 8px;
  }

  .top-banner{
    height: 184px;
    min-height: 184px;
  }

  .top-banner h1{
    font-size: 18px;
    font-weight: 700;
    line-height: 23px;
    margin: 40px auto 20px auto;
  }

  .top-banner h2{
    font-size: 14px;
    line-height: 18px;
    width: 80%;
  }

  .top-banner h1 span{
    display: block;
    font-size: 14px;
    line-height: 18px;
    margin-top: 20px;
  }

  .top-banner section{
    font-size: 13px;
    line-height: 16px;
  }

  .top-content p.banner-footer{
    font-size: 15px;
    line-height: 18px;
  }

   @supports (-webkit-touch-callout: none) {
    .filter-list span{
      line-height: 32px;
    }

    .filter-content .apply{
      line-height: 70px;
    }

    .top-link{
      padding-top: 12px;
    }

  }

}

@media screen and (max-width: 880px){

    .top-banner header .logo img{
      width: 60%;
    }

    .top-content p{
      width: 80%;
    }

}


@media screen and (max-width: 1024px){

  .top-banner section{
    max-width: 95%;
  }

  footer img{
    left: 78%;
  }

  .top-banner *, .body * {
    max-width: 95%;
  }

  .home-body{
    max-width: 95%;
  }
}

@media screen and (max-width: 880px){

  .top-banner{
    background: url(../img/banner-mobile2-bg.png) no-repeat 0 0;
    background-size: cover;
    border-radius: 0 0 0 100px;
    margin-left: 1.5%;
    padding-bottom: 46px;
    width: 98.5%;
  }

  .top-banner section{
    font-family: "GothamBook", sans-serif;
    font-size: 20px;
    line-height: 30px;
    font-weight: 100;
    width: 84%;
  }
  .top-banner section p{
    line-height: 20px;
  }

  .top-banner .super {
    font-size: 8px;
    font-weight: 100;
    margin: 0 0 0 2px;
    vertical-align: text-top;
}

  .top-content p.banner-footer{
    font-size: 30px;
    margin: 24px auto;
    width: 73%;
  }

  .home-body{
    width: 87%;
  }

}

@media screen and (max-width: 540px){

  .top-banner h1{
    font-size: 19px;
    line-height: 23px;
    max-width: 85%;
    margin: 40px auto 21px auto;
  }

  .top-banner h1 span{
    display: block;
    font-size: 19px;
    line-height: 23px;
  }

  .top-banner section{
    font-size: 13px;
    line-height: 16px;
  }

  .top-content p.banner-footer{
    font-size: 15px;
    line-height: 18px;
  }

}

@media screen and (max-width: 320px){

  footer li[data-v-40ab164b]:nth-child(2n){
    width: 42%;
  }
}


/* new styles sergio */

@media screen and (max-width: 880px){
    #boton {
      right: 20px;
      top: 38px;
    }
    header input ~ #menuToggle{
      width: 40px;
      height: 27px;
      right: 40px;
      top: 45px;
      background-size: cover;
    }
    header input:checked~#menuToggle{
        width: 28px;
        height: 28px;
        right: 40px;
        top: 45px;
        background-size: cover;
        z-index: 10000;
    }

    .top-banner header .logo img{
      width: 60%;
    }

}

@media screen and (max-width: 415px){

  .list-item{
    width: 74%;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/Site_Guide.vue